import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CsrfTokenService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  private _csrfToken = signal<string | null>(null);
  private _isLoading = signal<boolean>(false);
  private fetchPromise: Promise<string> | null = null;

  get csrfToken(): string | null {
    return this._csrfToken();
  }

  get isLoading(): boolean {
    return this._isLoading();
  }

  async fetchCsrfToken(): Promise<string> {
    const cachedToken = this._csrfToken();

    if (cachedToken) {
      return cachedToken;
    }

    if (this.fetchPromise) {
      return this.fetchPromise;
    }

    // Fetch new token
    this._isLoading.set(true);
    this.fetchPromise = firstValueFrom(
      this.http.get<{ token: string }>(`${this.configService.api.host}/csrf-token`)
    ).then((response) => {
      const { token } = response;

      this._csrfToken.set(token);
      this._isLoading.set(false);
      this.fetchPromise = null;

      return token;
    }).catch((error) => {
      this._isLoading.set(false);
      this.fetchPromise = null;
      console.error('Failed to fetch CSRF token:', error);
      throw error;
    });

    return this.fetchPromise;
  }
}

